import {Text, Button} from "@fluentui/react-components";
import * as React from "react";

interface ICaughtUpProps {
    onClickRefreshNewsfeed: () => void;
}
export default function CaughtUp (props: ICaughtUpProps){
    return  (
        <div className="smt-flex smt-flex__ai-center smt-flex__jc-center smt-filled smt-flex__gap-1 smt-flex__dir_column">
            <Text weight="semibold" size={400}>You're all caught up</Text>
            <Text style={{color: "var(--colorNeutralForeground4)"}}>There is nothing new for you to see right now</Text>
            <Button appearance="primary" onClick={props.onClickRefreshNewsfeed}>Refresh Newsfeed</Button>
        </div>
    );
}
